import Button from "@/common/elements/Button";
import { StyledGridCol, StyledGridRow } from "@/common/styles";

const FolderDetailSearchActions = ({
  onCancel,
  onSearch,
  onSelectCurrentJacket,
  onCreateNewJacket,
  isDisabledCurrentJacket,
}) => {
  return (
    <StyledGridRow gutter={16} justify="start">
      <StyledGridCol marginTop="10px">
        <Button type="default" color="default" onClick={onCancel}>
          Cancel
        </Button>
      </StyledGridCol>
      <StyledGridCol marginTop="10px">
        <Button type="default" color="default" onClick={onSearch}>
          Search
        </Button>
      </StyledGridCol>
      <StyledGridCol marginTop="10px">
        <Button
          type="default"
          color="default"
          onClick={onSelectCurrentJacket}
          disabled={isDisabledCurrentJacket}
        >
          Select Current Folder
        </Button>
      </StyledGridCol>
      <StyledGridCol marginTop="10px">
        <Button type="default" color="default" onClick={onCreateNewJacket}>
          Create New Folder
        </Button>
      </StyledGridCol>
    </StyledGridRow>
  );
};

export default FolderDetailSearchActions;
